<template>
  <v-container>
    <v-layout>
      <v-flex>
        <h3>Translate: English to Irish</h3>
        <h2 v-show="prompt">
          {{ this.conjEng }}
          <v-btn
            style="float: right"
            class="mx-2"
            small
            fab
            color="primary"
            @click="showHint = !showHint"
          >
            ?
          </v-btn>
        </h2>
      </v-flex>
    </v-layout>
    <v-layout column justify-space-around align-space-around>
      <v-card
        id="hint"
        v-show="showHint"
        color="primary"
        elevation="2"
        outlined
        style="max-width: 50%"
      >
        <div class="hintText">
          <p style="margin-bottom: 0 !important">
            <b>Tense: </b> {{ prompt.tense }}
          </p>
          <p style="margin-bottom: 0 !important">
            <b>Form: </b> {{ prompt.depForm }}
          </p>
        </div>
      </v-card>
    </v-layout>
    <v-layout>
      <v-flex>
        <div v-for="j in 6" v-bind:key="j">
          <v-card
            @click="markChoice(j)"
            rounded-lg
            block
            :color="buttonColor(j)"
            ripple
            class="mt-3 pa-2"
            :disabled="answered"
          >
          <v-flex
              align-self-center
              class="title"
            >

            <v-layout v-show="selectedChoice != j" justify-center pt-1 pb-1>
            <v-badge
              v-model="enumerated[j-1].length > 1"
              color="cyan"
            >
              <template v-slot:badge>
                <span>{{enumerated[j-1].length}}</span>
              </template>
              {{enumerated[j-1][0]}}
            </v-badge>
            </v-layout>
          </v-flex>
            <v-flex
              align-self-center
              class="title"
              v-for="word in enumerated[j - 1]"
              v-bind:key="word"
            >
              <v-layout v-show="selectedChoice === j" justify-center pt-1 pb-1>
                {{ stripAsterisk(word) }}
              </v-layout>
            </v-flex>
          </v-card>
        </div>
        <v-flex v-if="prompt" style="margin-bottom: 50px;">
          <h3 v-show="answered">{{ correct ? "Correct" : "Incorrect" }}</h3>
          <h3 v-show="answered">Answers</h3>
          <div
            v-show="answered"
            v-for="(answer, index) in prompt.answers"
            v-bind:key="index"
          >
            {{ answer }}
          </div>
        </v-flex>
        <v-layout mt-3 class="btn-bottom">
          <v-btn
            round
            outline
            flat
            color="primary"
            @click="checkWordButton(selectedChoice)"
            v-if="!answered && selectedChoice > 0"
            >Check</v-btn
          >
          <v-btn
            round
            outline
            flat
            color="primary"
            @click="handleSkip"
            v-if="!answered"
            >Skip</v-btn
          >
          <v-btn round outline flat color="primary" @click="handleSubmit" v-else
            >Next</v-btn
          >
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { SAMPLE_VERBS } from "@/constants.js";
import {
  conjugate,
  generateStem,
  enumerateConjugations,
  allFormsOfWord,
  removeAsterisk,
} from "@/conjugation.js";
import { randomConjugationPrompt } from "@/verbprompts.js";
import { translateConjugationPrompt } from "@/linguaEng.js";
import { user } from "firebase-functions/lib/providers/auth";
export default {
  name: "translationtoconjugation",
  props: {
    prompt: {
      type: Object,
      default: function () {
        return randomConjugationPrompt(_.sample(SAMPLE_VERBS));
      },
    },
    controlled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      verbStem: "",
      // dictionaryForm: _.sample(this.sampleVerbs),
      dictionaryForm: "",
      sampleVerbs: SAMPLE_VERBS,
      depForms: ["Dependent", "Independent"],
      depFormRadio: "None",
      // prompt: randomConjugationPrompt(_.sample(SAMPLE_VERBS)),
      verbAnswer: null,
      answered: false,
      correct: null,
      buttonColors: [],
      selectedChoice: -1,
      correctChoice: -1,
      showHint: false,
    };
  },
  methods: {
    handleAnswer() {
      this.correct =
        this.prompt.answers.indexOf(this.verbAnswer.toLowerCase) >= 0;
      this.$emit("check", { correct: this.correct });
      this.answered = true;
    },
    clear() {
      this.buttonColors = [];
      this.selectedChoice = this.correctChoice = -1;
      if (this.controlled) {
        this.$emit("next");
      }
      this.answered = false;
      this.verbAnswer = "";
    },
    handleSkip: function () {
      this.clear();
      if (!this.controlled) {
        this.prompt = randomConjugationPrompt(_.sample(SAMPLE_VERBS));
      }
      // this.conjEng = translateConjugationPrompt(this.prompt);
    },
    handleSubmit: function () {
      if (this.answered) {
        this.handleSkip();
      }
    },
    expandWord: function (word) {
      var wordString = allFormsOfWord(word).join(", ");
      return wordString;
    },
    checkWordButton(choiceIndex) {
      if (!this.answered) {
        var word = this.enumerated[choiceIndex - 1].join("\r\n");
        var correctAnswer = this.prompt.answers;
        this.correctChoice = this.enumerated.indexOf(correctAnswer);
        // turn array into string to remove groupings
        var userAnswer = allFormsOfWord(word).join("\r\n");
        // turn array back into string based on newline char
        userAnswer = userAnswer.split("\r\n");
        // just snag the first value in the array
        userAnswer = userAnswer[0];

        console.log(userAnswer);
        console.log(this.prompt.answers);
        this.correct =
          this.prompt.answers.indexOf(removeAsterisk(userAnswer)) >= 0;
        this.$emit("check", { correct: this.correct });
        this.answered = true;
      }
    },
    markChoice(index) {
      if(!this.answered)
      this.selectedChoice = index;
    },
    stripAsterisk(word) {
      return removeAsterisk(word);
    },
    buttonColor(btnIndex) {
      if(this.answered && this.correct && this.selectedChoice === btnIndex) return "green"
      else if (this.selectedChoice === btnIndex) return this.answered ? "red darken-3" : "cyan lighten-3";
      else return "grey lighten-3";
    },
  },
  computed: {
    conjEng() {
      return translateConjugationPrompt(this.prompt);
    },
    selectedVerbCategory() {
      var cat = this.sampleVerbs.find((x) => x.verb === this.prompt.verb);
      if (cat) return this.categories[cat.cat - 1];
      else return this.categories[0];
    },
    stem() {
      return generateStem(
        this.prompt.verb,
        this.prompt.category,
        this.prompt.tense
      );
    },
    enumerated() {
      this.dictionaryForm = this.prompt.verb;
      if (this.stem.length > 0) {
        return enumerateConjugations(
          this.prompt.category,
          this.prompt.tense,
          this.prompt.depForm,
          this.stem
        );
      }
    },
  },
};
</script>

<style scoped>
incorrect {
  color: red;
}
th,
td {
  outline: 1px solid black;
  padding: 1em;
}
button {
  /* white-space: normal;
  width: 200px;
  font-weight: bold;
  padding: 10px 5px;
  background-color: #F5F5F5;
  border-radius: 4px;
  margin: 5px;
  box-shadow: 0px 1px 2px #888888; */
  white-space: normal;
  width: 200px;
  font-weight: bold;
  padding: 10px 5px;
}

button:hover {
  background-color: #E0E0E0;
}

#wordButton {
  padding: 20px;
}

.hintText {
  color: white;
  padding: 20px;
  margin-bottom: 0px !important;
}
.choice-btn {
  text-transform: none;
  white-space: normal !important;
}
.btn-bottom {
  position: absolute;
  bottom: 0;
  padding: 16px 0px;
}
</style>